import * as Yup from 'yup'

const censoFormSchema = Yup.object({
  censo: Yup.mixed(),
})

export default censoFormSchema
